// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import ModelEventType from "./model-event-type.js"
import Template from "./template.js"

const modelClassData = {
  "attributes": {
    "attach_i_calendar": {
      "column": {
        "default": false,
        "name": "attach_i_calendar",
        "null": false,
        "type": "boolean"
      },
      "name": "attach_i_calendar",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "model_event_type_id": {
      "column": {
        "default": null,
        "name": "model_event_type_id",
        "null": false,
        "type": "uuid"
      },
      "name": "model_event_type_id",
      "selected_by_default": null,
      "translated": null
    },
    "requires_approval": {
      "column": {
        "default": true,
        "name": "requires_approval",
        "null": false,
        "type": "boolean"
      },
      "name": "requires_approval",
      "selected_by_default": null,
      "translated": null
    },
    "resource_id": {
      "column": {
        "default": null,
        "name": "resource_id",
        "null": true,
        "type": "uuid"
      },
      "name": "resource_id",
      "selected_by_default": null,
      "translated": null
    },
    "resource_type": {
      "column": {
        "default": null,
        "name": "resource_type",
        "null": true,
        "type": "string"
      },
      "name": "resource_type",
      "selected_by_default": null,
      "translated": null
    },
    "send_email": {
      "column": {
        "default": false,
        "name": "send_email",
        "null": false,
        "type": "boolean"
      },
      "name": "send_email",
      "selected_by_default": null,
      "translated": null
    },
    "send_sms": {
      "column": {
        "default": false,
        "name": "send_sms",
        "null": false,
        "type": "boolean"
      },
      "name": "send_sms",
      "selected_by_default": null,
      "translated": null
    },
    "template_id": {
      "column": {
        "default": null,
        "name": "template_id",
        "null": false,
        "type": "uuid"
      },
      "name": "template_id",
      "selected_by_default": null,
      "translated": null
    },
    "resource_label": {
      "column": null,
      "name": "resource_label",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "SendingRule",
  "collectionKey": "sending_rules",
  "collectionName": "sending_rules",
  "i18nKey": "sending_rule",
  "camelizedLower": "sendingRule",
  "name": "SendingRule",
  "nameDasherized": "sending-rule",
  "pluralName": "sending_rules",
  "ransackable_associations": [
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "ModelEventType",
      "collectionName": "model_event_types",
      "foreignKey": "model_event_type_id",
      "name": "model_event_type",
      "macro": "belongs_to",
      "resource_name": "ModelEventType",
      "through": null
    },
    {
      "className": "Resource",
      "collectionName": null,
      "foreignKey": "resource_id",
      "name": "resource",
      "macro": "belongs_to",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Template",
      "collectionName": "templates",
      "foreignKey": "template_id",
      "name": "template",
      "macro": "belongs_to",
      "resource_name": "Template",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "attach_i_calendar",
      "column": {
        "default": false,
        "name": "attach_i_calendar",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "model_event_type_id",
      "column": {
        "default": null,
        "name": "model_event_type_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_model_event_type_id",
      "column": {
        "default": null,
        "name": "old_model_event_type_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_resource_id",
      "column": {
        "default": null,
        "name": "old_resource_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_template_id",
      "column": {
        "default": null,
        "name": "old_template_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "requires_approval",
      "column": {
        "default": true,
        "name": "requires_approval",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "resource_id",
      "column": {
        "default": null,
        "name": "resource_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "resource_type",
      "column": {
        "default": null,
        "name": "resource_type",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "send_email",
      "column": {
        "default": false,
        "name": "send_email",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "send_sms",
      "column": {
        "default": false,
        "name": "send_sms",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "template_id",
      "column": {
        "default": null,
        "name": "template_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "ModelEventType",
      "collectionName": "model_event_types",
      "foreignKey": "model_event_type_id",
      "name": "model_event_type",
      "macro": "belongs_to",
      "resource_name": "ModelEventType",
      "through": null
    },
    {
      "className": "Template",
      "collectionName": "templates",
      "foreignKey": "template_id",
      "name": "template",
      "macro": "belongs_to",
      "resource_name": "Template",
      "through": null
    }
  ],
  "paramKey": "sending_rule",
  "primaryKey": "id"
}

/** Frontend model for SendingRule. */
export default class SendingRule extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {boolean} */
  attachICalendar() {
    return this.readAttributeUnderscore("attach_i_calendar")
  }

  /** @returns {boolean} */
  hasAttachICalendar() {
    const value = this.attachICalendar()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  modelEventTypeId() {
    return this.readAttributeUnderscore("model_event_type_id")
  }

  /** @returns {boolean} */
  hasModelEventTypeId() {
    const value = this.modelEventTypeId()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  requiresApproval() {
    return this.readAttributeUnderscore("requires_approval")
  }

  /** @returns {boolean} */
  hasRequiresApproval() {
    const value = this.requiresApproval()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  resourceId() {
    return this.readAttributeUnderscore("resource_id")
  }

  /** @returns {boolean} */
  hasResourceId() {
    const value = this.resourceId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  resourceType() {
    return this.readAttributeUnderscore("resource_type")
  }

  /** @returns {boolean} */
  hasResourceType() {
    const value = this.resourceType()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  sendEmail() {
    return this.readAttributeUnderscore("send_email")
  }

  /** @returns {boolean} */
  hasSendEmail() {
    const value = this.sendEmail()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  sendSms() {
    return this.readAttributeUnderscore("send_sms")
  }

  /** @returns {boolean} */
  hasSendSms() {
    const value = this.sendSms()

    return this._isPresent(value)
  }

  /** @returns {string} */
  templateId() {
    return this.readAttributeUnderscore("template_id")
  }

  /** @returns {boolean} */
  hasTemplateId() {
    const value = this.templateId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  resourceLabel() {
    return this.readAttributeUnderscore("resource_label")
  }

  /** @returns {boolean} */
  hasResourceLabel() {
    const value = this.resourceLabel()

    return this._isPresent(value)
  }

  /** @returns {import("./model-event-type.js").default | null} */
  modelEventType() {
    return this._readBelongsToReflection({modelClass: ModelEventType, reflectionName: "model_event_type"})
  }

  /** @returns {Promise<import("./model-event-type.js").default | null>} */
  loadModelEventType() {
    if (!("modelEventTypeId" in this)) throw new Error("Foreign key method wasn't defined: modelEventTypeId")

    const id = this.modelEventTypeId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "model_event_type",
        model: this,
        modelClass: ModelEventType
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./model-event-type.js").default | null>} */
  ensureModelEventTypeLoaded() {
    return this.ensureAssociationLoaded("model_event_type")
  }

  /** @returns {import("./template.js").default | null} */
  template() {
    return this._readBelongsToReflection({modelClass: Template, reflectionName: "template"})
  }

  /** @returns {Promise<import("./template.js").default | null>} */
  loadTemplate() {
    if (!("templateId" in this)) throw new Error("Foreign key method wasn't defined: templateId")

    const id = this.templateId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "template",
        model: this,
        modelClass: Template
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./template.js").default | null>} */
  ensureTemplateLoaded() {
    return this.ensureAssociationLoaded("template")
  }
}
